import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "50",
  height: "50",
  viewBox: "0 0 19 19"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs></defs><g id=\"Group_2910\" transform=\"translate(-55 -1495)\"><g id=\"Group_2908\" transform=\"translate(-39 56)\"><g id=\"Group_2909\"><circle id=\"Ellipse_1\" cx=\"9.5\" cy=\"9.5\" r=\"9.5\" fill=\"#f0ea48\" transform=\"translate(94 1439)\"></circle><g id=\"Group_2907\" transform=\"translate(-2.118 -1)\"><path id=\"Path_2565\" d=\"M0 9.188 3.67 0\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" transform=\"rotate(-6.02 13778.75 -265.67)\"></path><path id=\"Path_2566\" d=\"M0 9.188 3.67 0\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" transform=\"rotate(-6.02 13783.11 -290.25)\"></path><path id=\"Rectangle_2245\" d=\"M0 0h2v2H0z\" fill=\"#fff\" transform=\"translate(101 1446)\"></path><path id=\"Rectangle_2246\" d=\"M0 0h2v2H0z\" fill=\"#fff\" transform=\"translate(101 1451)\"></path></g></g></g></g>", 2)
const _hoisted_4 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };